module.exports = __webpack_public_path__ + "static/media/bg.0e13cc42.jpg";